import { Button } from "@/common/elements/button";
import {
  UiPaymentMethodType,
  type UiPaymentMethod,
} from "@/plugins/controls/common/billing-mappers";

type PaymentMethodItemProps = {
  method: UiPaymentMethod;
  onEdit: (method: UiPaymentMethod) => void;
};

export function PaymentMethodItem({ method, onEdit }: PaymentMethodItemProps) {
  let methodNickname = "";
  if (method.nickname) {
    methodNickname = `${method.nickname} - `;
  }
  const methodTitle =
    method.type === UiPaymentMethodType.Card
      ? `${methodNickname}${method.brand} ending in ${method.last4}`
      : `${methodNickname}ACH ${method.accountType} ending in ${method.accountLast4}`;

  const methodDetails =
    method.type === UiPaymentMethodType.Card
      ? `Expires ${method.expMonth}/${method.expYear} • ${method.billingName}`
      : `${method.bankName} • ${method.billingName}`;

  return (
    <article className="rounded-lg border p-4">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="font-medium">{methodTitle}</p>
          <p className="text-sm text-muted-foreground">{methodDetails}</p>
        </div>
        <div className="flex items-center gap-2">
          <span className="rounded-full border px-2 py-1 text-xs font-medium uppercase">
            {method.type}
          </span>
          {method.isDefault ? (
            <span className="rounded-full bg-emerald-100 px-2 py-1 text-xs font-medium text-emerald-800">
              Default
            </span>
          ) : null}
          {method.isDisabled ? (
            <span className="rounded-full bg-rose-100 px-2 py-1 text-xs font-medium text-rose-800">
              Disabled
            </span>
          ) : null}
          <Button size="sm" variant="outline" onClick={() => onEdit(method)}>
            Manage
          </Button>
        </div>
      </div>
    </article>
  );
}
